<template>
  <modal-wrapper class="bto-sb-modalbox-scroll bto-sb-modalpopup-xl" @close="close">
    <div class="bto-sb-modalpopup">
      <div class="bto-sb-modalpopup-title">
        <button type="button" @click.stop="close"><i class="bto-app-delete"></i></button>
        <h4 v-if="notTopWinnings">{{ t('BetSlip.Details') }} - {{ betDetails.betSlipGroupID }}</h4>
        <h4 v-else>{{ t('Mobile.Winnings') }} </h4>
      </div>
      <div class="bto-sb-modalpopup-content">
        <div class="bto-sb-mybets-modal bto-sb-negotiation-modal">
          <div class="bto-sb-negotiation-content">
            <mybets-details :notTopWinnings="notTopWinnings" :betDetails="betDetails" />
          </div>
        </div>
      </div>
    </div>
  </modal-wrapper>
</template>
<script>
  import ModalWrapper from '../../../../components/shared/modal-wrapper';
  import MybetsDetails from '../../../../components/shared/mybets/mybet-details/web';
  import { modalFocus } from '../../../../services/toastr';

  export default {
    name: 'MybetsDetailsModal',
    components: { ModalWrapper, MybetsDetails },
    props: {
      betDetails: {
        type: Object,
        required: true,
      },
      notTopWinnings: {
        type: Boolean,
        default: true,
      },
    },
    methods: {
      close() {
        modalFocus();
        this.$emit('close-betslip-details');
      },
    },
  };
</script>